import { MDXProvider } from '@mdx-js/react'
import { Table } from '@vp/visage'
import { MDXRenderer } from 'gatsby-plugin-mdx' // eslint-disable-line
import React, { FC } from 'react'
import { CodeBlocks, PreCodeBlock } from '../../sandboxes/_internal/code-block/code-blocks.component'
// import { Mdx } from '../../types/graphql-types'

const components = {
  CodeBlocks,
  pre: PreCodeBlock,
  table: Table,
}

export type ContentRendererProps = {
  mdx?: Pick<GatsbyTypes.Mdx, 'body'>
}

const MdxRenderer: FC<ContentRendererProps> = ({ mdx }) =>
  mdx && mdx.body ? (
    <MDXProvider components={components}>
      <MDXRenderer>{mdx.body}</MDXRenderer>
    </MDXProvider>
  ) : null

export default MdxRenderer
